// 版本號由 build-deploy*.sh 以根目錄 VERSION 帶入；本機 npm start 取 package.json version（見 frontend/.env）
export const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';
export const APP_GIT_COMMIT = process.env.REACT_APP_GIT_COMMIT || '';
export const APP_VERSION_LABEL = `v${APP_VERSION}${APP_GIT_COMMIT ? ` (${APP_GIT_COMMIT})` : ''}`;
